import React from "react";
import FooterLogo from "../../assets/footer_logo.svg";
import Facebook from "../Icons/facebook";
import Instagram from "../Icons/Instagram";
import Linkedin from "../Icons/Linkedin";
import BackToTop from "../Icons/Top";
import { Link } from "react-router-dom";
import { CONSTANTS } from "../../helpers/Constant";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <footer className="bg-blue-500 py-14 md:block hidden">
        <div className="container sm:container md:container lg:container w-full mx-auto text-center">
          <div className="flex flex-col lg:flex-row justify-between items-center">
            <div className="flex flex-col md:flex-row items-center">
              <img src={FooterLogo} alt="" title="" />
              <span className="md:text-sm text-xs text-white opacity-70 px-5 py-3 md:py-0 font-avenirNextRegular">
                Copyright &copy; 2023. {CONSTANTS.COMPANY_NAME} IT Consulting AB
                - 556593-8973
              </span>
            </div>
            <div className="flex flex-col md:flex-row items-center md:py-0 py-3">
              <ul className="flex flex-row md:text-sm text-xs text-white opacity-70 px-3 font-avenirNextRegular">
                {/* <li className="px-2">
                  <Link to="/privacy-policies">
                    Product &amp; Privacy Policies
                  </Link>
                </li>{" "}
                | */}
                <li className="px-2">
                  <Link to="/privacy-gdprs">GDPR - Privacy Notice</Link>
                </li>
              </ul>
              <div className="flex flex-row  md:pt-0 pt-3">
                <a
                  href="https://www.facebook.com/2MNordic"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Facebook"
                >
                  <Facebook
                    width="28"
                    height="28"
                    className="text-white opacity-70 mx-2 cursor-pointer"
                  />
                </a>
                <a
                  href="https://www.instagram.com/2mnordic/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Instagram"
                >
                  <Instagram
                    width="28"
                    height="28"
                    className="text-white opacity-70 mx-2 cursor-pointer"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/2mnordic-it-consulting-ab/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Linkedin"
                >
                  <Linkedin
                    width="28"
                    height="28"
                    className="text-white opacity-70 mx-2 cursor-pointer"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <footer className="bg-blue-500 py-6  text-white text-center px-5 block md:hidden">
        <span
          className="cursor-pointer flex flex-row  justify-center items-center"
          onClick={scrollToTop}
        >
          Back top Top{" "}
          <BackToTop className="text-white ml-3" width="20" height="20" />
        </span>
      </footer>
    </>
  );
};

export default Footer;
